import cn from 'classnames';
import { FC } from 'react';

import { useAppDispatch, useAppSelector } from '@/shared/hooks';

import { organizationModel } from '@/entities/organization';
import { reportsModel } from '@/entities/reports';
import { toothModel } from '@/entities/tooth';

import { RenderViewSlider } from '@/features/renderViewSlider';

import styles from './PanoImageSlider.module.scss';

type PanoImageSliderProps = {
  className?: string;
  reportID: string;
};

export const PanoImageSlider: FC<PanoImageSliderProps> = (props) => {
  const { className, reportID } = props;

  const dispatch = useAppDispatch();

  const { isFDAVersion2 } = useAppSelector(
    organizationModel.selectors.selectFDAEnvironment,
  );

  const teethIDs = useAppSelector(
    toothModel.selectors.selectTeethIDsToShow(
      reportID as string,
      isFDAVersion2,
    ),
  );
  const activeToothID = useAppSelector(
    reportsModel.selectors.selectActiveToothID,
  );

  const updateActiveToothID = (newToothID: string) => {
    dispatch(reportsModel.actions.setToolbarActiveControl('view'));
    dispatch(reportsModel.actions.setActiveToothID(newToothID));
  };

  return (
    <RenderViewSlider
      updateActiveItem={updateActiveToothID}
      itemIDs={teethIDs}
      activeItemID={activeToothID}
      className={cn(styles.container, className)}
    />
  );
};
